import { useState } from "react";
import { completePasswordReset } from "../api/auth";
import AsyncButton from "../components/AsyncButton";
import StatusMessage from "../components/StatusMessage";
import { getErrorMessage } from "../utils/apiErrors";
import { getStoredUser, homeForRole, storeUser } from "../utils/session";

function getUser() {
  return getStoredUser();
}

function redirectForRole(role) {
  window.location.href = homeForRole(role);
}

export default function ForcePasswordReset() {
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await completePasswordReset(password, passwordConfirmation);
      const currentUser = getUser();
      const updatedUser = {
        ...currentUser,
        ...(res.data.user || {}),
        must_reset_password: false,
      };

      storeUser(updatedUser);
      redirectForRole(updatedUser.role);
    } catch (err) {
      setError(getErrorMessage(err, "Unable to update password."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="d-flex align-items-center gap-3 mb-4">
          <div className="brand-mark">CV</div>
          <div>
            <h4 className="mb-0">CounselVault</h4>
            <div className="text-muted small">Private credential setup</div>
          </div>
        </div>

        <h2 className="fw-bold mb-2">Create Your Private Password</h2>
        <p className="text-muted">
          Your temporary PIN can only be used to activate access. Facility staff will not know your final password.
        </p>

        <StatusMessage type="warning">{error}</StatusMessage>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">New password</label>
            <input
              type="password"
              className="form-control form-control-lg"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength="12"
              required
            />

            <div className="form-text">
              Use at least 12 characters with uppercase, lowercase, a number, and a symbol. It cannot match the temporary credential.
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label">Confirm password</label>
            <input
              type="password"
              className="form-control form-control-lg"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              minLength="12"
              required
            />
          </div>

          <AsyncButton className="btn btn-dark btn-lg w-100" busy={loading} busyText="Saving…">Save Password</AsyncButton>
        </form>
      </div>
    </div>
  );
}
